import { xBaseTheme } from "@eisinc/XDL/types";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            position: relative;
        `,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        toggleTransition: {
            positionerCss: css`
                position: absolute;
            `,
        },
        panelProps: {
            css: css`
                border: 0;
                padding-top: 0;
                font-size: 16px;
            `,
        },
        titleTypographyProps: {
            css: css`
                font-weight: normal;
                color: ${getColor("text.main")};
                line-height: 24px;
            `,
            size: 16,
        },
        toggleIconProps: {
            ...AccordionSectionPresentationPropsDefault?.toggleIconProps,
            color: "common.ui1",
        },
        collapseIconProps: {
            color: "common.ui1",
        },
        headerProps: {
            css: css`
                background: none;
                button {
                    border-left: 0;
                    border-right: 0;
                    border-bottom: 0;
                    padding: 15px;
                    background: none;

                    &:focus {
                        padding: 15px;
                        border-width: 0;
                        border-top-width: 1px;
                        border-top-color: ${getColor("secondary")};
                    }
                }
                button[aria-expanded="true"] {
                    span {
                        font-size: 20px;
                        letter-spacing: 0.5px;
                        font-weight: 600;
                    }
                }
                ${/* sc-selector */ AccordionSectionPanel} + & button {
                    border-top: 1px solid ${getColor("common.ui2")};
                }
            `,
        },
    },
} as xBaseTheme["accordion"];
